var locationNotes = (function () {
    //-DOM------------------
    //*all
    var allNotesPage;
    var allNotesList;
    //*single
    var singleNotePage;
    var singleNotesList;
    //-DATA-----------------
    var allNotesData;
    var singleNoteData;
    //-VALUES---------------
    var selectedLocation;
    var selectedLocationId;
    let isSortDescending = false;

    // UTIL
    //---------------------------------------------
    function formatTime(datecreated) {
        // datecreated = "11/6/2019 8:49:11 AM"
        var datecreatedArray = datecreated.split(' ');
        var time = datecreatedArray[1].split(':');
        time = `${time[0]}:${time[1]} ${datecreatedArray[2]}`;
        return time;
    }
    function sortDataByDate(data) {
        if (!data || !Array.isArray(data)) return [];

        return data.sort((a, b) => {
            var dateA, dateB;
            if (a.datecreated && b.datecreated) {
                dateA = new Date(a.datecreated);
                dateB = new Date(b.datecreated);
            } else if (a.Date_Entered && b.Date_Entered) {
                dateA = new Date(a.Date_Entered);
                dateB = new Date(b.Date_Entered);
            } else {
                return 0;
            }
            if (isNaN(dateA.getTime())) dateA = new Date(0);
            if (isNaN(dateB.getTime())) dateB = new Date(0);
            if (dateA > dateB) {
                return -1;
            } else if (dateA < dateB) {
                return 1;
            } else {
                return 0;
            }
        });
    }
    function buildNoteImage() {
        return `<img class="pic" src="./images/new-icons/default.jpg"/>`;
    }
    function buildNoteAuthorName(name) {
        return `<p class="name">${name || ''}</p>`;
    }
    function buildNoteDateTime(date, time) {
        return `<div class="dateTime"><p>${date || ''}</p><p>${time || ''}</p></div>`;
    }
    function buildNoteTitle(title) {
        return `<p class="title">${title || ''}</p>`;
    }
    function buildNoteText(text) {
        return `<p>${text || ''}</p>`;
    }
    function buildNoteDetails(image, name, dateTime) {
        var details = document.createElement('div');
        details.classList.add('locationNote__details');
        details.innerHTML = `${image}${name}${dateTime}`;
        return details;
    }
    function buildNoteMessage(title, notePreview) {
        var message = document.createElement('div');
        message.classList.add('locationNote__message');
        message.innerHTML = `${title}${notePreview}`;
        return message;
    }
    function buildNote(details, message) {
        var note = document.createElement('div');
        note.classList.add('locationNote');
        note.appendChild(details);
        note.appendChild(message);
        return note;
    }
    function buildTitleInput() {
        return input.build({
            label: 'Title',
            style: 'secondary',
            type: 'text',
            attributes: [{ key: 'maxlength', value: '250' }],
        });
    }
    function buildTextInput() {
        return input.build({
            label: 'Message',
            style: 'secondary',
            type: 'textarea',
            attributes: [{ key: 'maxlength', value: '10000' }],
        });
    }   
    function buildSendBtn() {
        return button.build({
            text: 'Send',
            type: 'contained',
            style: 'secondary',
        });
    }
    // Single Note Page
    //---------------------------------------------
    function getSingleNoteData(noteId, callback) {
        locationNotesAjax.selectLocationNote(noteId, function (results) {
            singleNoteData = sortDataByDate(results);
            if (typeof callback === 'function') {
                callback();
            }
        });
    }
    function handleReplyToNoteBtnClick(noteId) {
        // build
        var notePopup = POPUP.build({});
        var noteTextInput = buildTextInput();
        var sendNoteBtn = buildSendBtn();
        sendNoteBtn.classList.add('disabled');
        notePopup.appendChild(noteTextInput);
        notePopup.appendChild(sendNoteBtn);
        // show
        POPUP.show(notePopup);
        // events
        var noteText = '';
        var noteTextElement = noteTextInput.querySelector('textarea') || noteTextInput.querySelector('input');
        if (noteTextElement) {
            noteTextElement.addEventListener('input', event => {
                noteText = event.target.value;
                if (noteText.trim()) {
                    sendNoteBtn.classList.remove('disabled');
                } else {
                    sendNoteBtn.classList.add('disabled');
                }
            });
        }
        sendNoteBtn.addEventListener('click', event => {
            locationNotesAjax.updateLocationNote(
                {
                    token: $.session.Token,
                    noteId: noteId,
                    locationId: selectedLocationId,
                    note: UTIL.removeUnsavableNoteText(noteText),
                },
                results => {
                    POPUP.hide(notePopup);
                    loadSingleNotePage(noteId);
                },
            );
        });
    }
    function populateSingleNotePage(noteId) {
        if (!singleNoteData || !Array.isArray(singleNoteData)) {
            return;
        }
        singleNotesList.innerHTML = '';
        singleNoteData.forEach(note => {
            var noteDate = note.Date_Entered ? note.Date_Entered.split(' ')[0] : '';
            var noteTime = note.Date_Entered ? formatTime(note.Date_Entered) : '';
            var noteAuthor = `${note.firstname || ''} ${note.lastname || ''}`.trim();
            var noteTitle = note.notetitle || '';
            var noteText = note.note || '';
            var empId = note.emp_id;
            var image = buildNoteImage(empId);   
            var name = buildNoteAuthorName(noteAuthor);
            var dateTime = buildNoteDateTime(noteDate, noteTime);
            var title = buildNoteTitle(noteTitle);
            var notePreview = buildNoteText(noteText);
            var details = buildNoteDetails(image, name, dateTime);
            var message = buildNoteMessage(title, notePreview);
            var noteElement = buildNote(details, message);
            singleNotesList.appendChild(noteElement);
        });

        var topNav = document.createElement('div');
        topNav.classList.add('locationNotesTopNav');

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');

        var backToNotesMain = button.build({
            text: 'Back To Notes',
            icon: 'arrowBack',
            type: 'text',
            style: 'secondary',
            classNames: 'backToRosterBtn',
            callback: function () {
                loadAllNotesPage();
            },
        });
        var newNoteBtn = button.build({
            text: 'New Note',
            type: 'contained',
            style: 'secondary',
            classNames: 'newNoteBtn',
            callback: function () {
                handleReplyToNoteBtnClick(noteId);
            },
        });

        var locationLabel = document.createElement('div');
        locationLabel.classList.add('locationLabel');
        locationLabel.innerHTML = `<h2>${selectedLocation.locationName || 'Unknown Location'}</h2>`;
        btnWrap.appendChild(backToNotesMain);
        btnWrap.appendChild(newNoteBtn);

        topNav.appendChild(btnWrap);
        topNav.appendChild(locationLabel);
        singleNotePage.innerHTML = '';
        singleNotePage.appendChild(topNav);
        singleNotePage.appendChild(singleNotesList);
    }    
    function buildSingleNotePage() {
        singleNotePage = document.createElement('div');
        singleNotePage.classList.add('locationSingleNotePage');

        singleNotesList = document.createElement('div');
        singleNotesList.classList.add('locationNotesList');

        DOM.ACTIONCENTER.appendChild(singleNotePage);
    }
    function loadSingleNotePage(noteId) {
        getSingleNoteData(noteId, function () {
            DOM.clearActionCenter();
            buildSingleNotePage();
            populateSingleNotePage(noteId);
        });
    }

    // Main Page
    //---------------------------------------------
    function getLocationNotesData(callback) {
        locationNotesAjax.getLocationProgressNotes(selectedLocationId, function (results) {
            allNotesData = sortDataByDate(results);
            if (typeof callback === 'function') {
                callback();
            }
        });

        // locationNotesAjax.doesLocationHaveUnreadNotes(selectedLocationId, function(results) {
        //   // hasNote: "0"
        // });
    }
    function handleNewNoteBtnClick() {
        // build
        var notePopup = POPUP.build({});
        var noteTitleInput = buildTitleInput();
        var noteTextInput = buildTextInput();
        var sendNoteBtn = buildSendBtn();
        notePopup.appendChild(noteTitleInput);
        notePopup.appendChild(noteTextInput);
        notePopup.appendChild(sendNoteBtn);
        // show
        POPUP.show(notePopup);
        var noteTitle = '';
        var noteText = '';
        var titleElement = noteTitleInput.querySelector('input');
        var textElement = noteTextInput.querySelector('textarea') || noteTextInput.querySelector('input');
        if (titleElement) {
            titleElement.addEventListener('input', event => {
                noteTitle = event.target.value;
            });
        }
        if (textElement) {
            textElement.addEventListener('input', event => {
                noteText = event.target.value;
            });
        }
        sendNoteBtn.addEventListener('click', event => {
            if (sendNoteBtn.classList.contains('disabled')) {
                return;
            }
            locationNotesAjax.insertLocationNote(
                {
                    token: $.session.Token,
                    noteTitle: UTIL.removeUnsavableNoteText(noteTitle),
                    note: UTIL.removeUnsavableNoteText(noteText),
                    locationId: selectedLocationId,
                },
                results => {
                    POPUP.hide(notePopup);
                    loadAllNotesPage();
                },
            );
        });
    }
    function parseUSDate(str) {
        const date = new Date(str);
        return isNaN(date.getTime()) ? 0 : date.getTime();
    }
    function populateAllNotesPage() {
        if (!allNotesData || !Array.isArray(allNotesData)) {
            return;
        }
        allNotesPage.innerHTML = '';
        const topNav = document.createElement('div');
        topNav.classList.add('locationNotesTopNav');

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.style.display = 'flex';
        btnWrap.style.flexDirection = 'column';
        btnWrap.style.gap = '8px';

        const buttonRow = document.createElement('div');
        buttonRow.style.display = 'flex';
        buttonRow.style.alignItems = 'center';
        buttonRow.style.gap = '8px';

        const backToRoster = button.build({
            text: 'Back To Roster',
            icon: 'arrowBack',
            type: 'text',
            style: 'secondary',
            classNames: 'backToRosterBtn',
            callback: () => roster2.loadRosterInfo(),
        });
        const newNoteBtn = button.build({
            text: 'New Note',
            type: 'contained',
            style: 'secondary',
            classNames: 'newNoteBtn',
            callback: handleNewNoteBtnClick,
        });

        buttonRow.appendChild(backToRoster);
        buttonRow.appendChild(newNoteBtn);

            // 2) Checkbox row, aligned right
        const sortCheckboxWrap = document.createElement('div');
        sortCheckboxWrap.style.alignSelf = 'flex-end';
        sortCheckboxWrap.style.display = 'flex';
        sortCheckboxWrap.style.alignItems = 'center';

        const sortCheckbox = document.createElement('input');
        sortCheckbox.type = 'checkbox';
        sortCheckbox.id = 'allNotesSortCheckbox';
        sortCheckbox.checked = isSortDescending;

        const sortLabel = document.createElement('label');
        sortLabel.htmlFor = 'allNotesSortCheckbox';
        sortLabel.textContent = 'Show Newest On Top';
        sortLabel.style.fontWeight = 'bold';
        sortLabel.style.marginRight = '4px';
        sortCheckbox.addEventListener('change', () => {
            isSortDescending = sortCheckbox.checked;
            populateAllNotesPage();
        });

            // Append label FIRST, then checkbox for "Show Newest On Top []" layout
        sortCheckboxWrap.appendChild(sortLabel);
        sortCheckboxWrap.appendChild(sortCheckbox);

            // assemble btnWrap
        btnWrap.appendChild(buttonRow);
        btnWrap.appendChild(sortCheckboxWrap);

            // 3) Location label
        const locationLabel = document.createElement('div');
        locationLabel.classList.add('locationLabel');
        locationLabel.innerHTML = `<h2>${selectedLocation?.locationName || 'Unknown Location'}</h2>`;
        topNav.appendChild(btnWrap);
        topNav.appendChild(locationLabel);

        allNotesPage.appendChild(topNav);
        allNotesList = document.createElement('div');
        allNotesList.classList.add('locationNotesList');
        const sortedNotes = [...allNotesData].sort((a, b) => {
            const aTime = parseUSDate(a.datecreated);
            const bTime = parseUSDate(b.datecreated);
            return isSortDescending ? (bTime - aTime) : (aTime - bTime);
        });
        sortedNotes.forEach(note => {
            const noteId = note.noteID;
            const noteRead = note.is_read === '1';
            const dateParts = note.datecreated ? note.datecreated.split(' ') : ['', '', ''];
            const datePart = dateParts[0] || '';
            const timePart = dateParts[1] || '';
            const ampm = dateParts[2] || '';

            let displayTime = '';
            if (timePart) {
                const timeComponents = timePart.split(':');
                if (timeComponents.length >= 2) {
                    displayTime = `${timeComponents[0]}:${timeComponents[1]} ${ampm}`;
                }
            }
            const image = buildNoteImage(note.empId);
            const nameEl = buildNoteAuthorName(note.MainAuthor);
            const dtEl = buildNoteDateTime(datePart, displayTime);
            const titleEl = buildNoteTitle(note.title);
            const textEl = buildNoteText(note.note);
            const details = buildNoteDetails(image, nameEl, dtEl);
            const message = buildNoteMessage(titleEl, textEl);
            const noteEl = buildNote(details, message);
            if (!noteRead) {
                noteEl.classList.add('unreadNote');
            }
            noteEl.addEventListener('click', () => {
                noteEl.classList.remove('unreadNote');
                locationNotesAjax.updateLocationNoteDateRead(noteId, () => {
                    loadSingleNotePage(noteId);
                });
            });

            allNotesList.appendChild(noteEl);
        });

        allNotesPage.appendChild(allNotesList);
    }
    function buildAllNotesPage() {
        allNotesPage = document.createElement('div');
        allNotesPage.classList.add('locationAllNotesPage');
        DOM.ACTIONCENTER.appendChild(allNotesPage);
    }
    function loadAllNotesPage() {
        selectedLocation = roster2.getSelectedLocationObj();
        selectedLocationId = selectedLocation?.locationId;
        if (!selectedLocationId) {
            return;
        }
        getLocationNotesData(function () {
            DOM.clearActionCenter();
            setActiveModuleSectionAttribute('roster-location-notes');
            buildAllNotesPage();
            populateAllNotesPage();
        });
    }

    return {
        loadAllNotesPage,
    };
})();
